
<div class="row pad25 modalPad" [ngStyle]="{ 'padding-top': isClosSettingShow ? '15px' : null, 'background': '#F8F8F8', 'max-width': '1150px', 'margin-left': 'auto', 'margin-right': 'auto', 
'border-radius': isMobileView ? '0px' : null }">
    <div class="col-md-12 col-12 col-sm-12 padZero" style="{{isClosSettingShow ? 'padding-left: 5px; padding-right: 5px;' : 'padding: 0px;'}}">
        <div class="col-md-12 col-12 col-sm-12 pad0 {{isClosSettingShow ? 'modal-header' : ''}}" style="{{isClosSettingShow ? 'padding-bottom: 10px;' : ''}}">
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk lblHeader newHeader" style="vertical-align: top;">
                    <h4 style="font-size: 22px;">{{data.ItemID == 0 ? 'Enter Item' : 'Update Item' }}</h4>
                </div>
                <div class="col-md-7 col-7 col-sm-7 txtRight pad0 inLneBlk">
                    <span class="btn btn-darkBlue fntSz brdrRadius3" (click)="open();" title="Settings" *ngIf="!isClosSettingShow" 
                        style="cursor: pointer; margin-left: 10px; padding: 7px 9px; line-height: 0px; font-size: 14px; margin-right: 10px;">
                        <span>
                            <i class="fa fa-cog" aria-hidden="true"></i>
                        </span>
                    </span>

                    <span *ngIf="!showAsPage" class="btn-darkGreen ng-scope brdrRadius3" style="margin-right: 7px;padding: 1px 7px 1px; font-size: 13px; height: 30px;" (click)="save()">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>
                        {{data.ItemID == 0 ? 'Save' : 'Update'}}
                    </span>
                    <div *ngIf="!showAsPage" style="display: inline-block;">
                        <span class="closeMdl ng-scope" *ngIf="!isClosSettingShow" style="margin-right: 0%; padding: 7px 12px !important;"
                        (click)="closeModel()">
                            <i class="zmdi zmdi-close"></i>
                        </span>
                    </div>
                    <span *ngIf="showAsPage" class="btn darkBlueButton" (click)="backToHomeBtn()">
                        <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                    </span>
                </div>
            </div>
            
        </div>      
        <!-- Mobile View -->
        <div class="{{isClosSettingShow ? 'modal-body' : ''}} mobView" style="{{isClosSettingShow ? 'padding-left: 5px;' : ''}}">    
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="row">
                    <div class="col-md-12 col-12 col-sm-12 mobView">
                        <div class="label-new" style="color: #333; display: inline-block; ;">Type <span class="redText margTop10">*</span></div>
                        <!-- Stores -->
                        <div>
                            <mat-select class="form-control bzInput" style=" width: 150px; padding: 5px 8px; font-size: 13px;"
                            [(ngModel)]="modeType" (ngModelChange)="changeMode(modeType)">
                                <mat-option [value]="1">Product</mat-option>
                                <mat-option [value]="2">Material</mat-option>
                                <mat-option [value]="3">Spare</mat-option>
                                <mat-option [value]="3">Assembly</mat-option>
                              </mat-select>
                            <!-- <select class="form-control bzInput" style=" width: 150px; padding: 3px;" [(ngModel)]="data.IsMade"
                            (ngModelChange)="changeMode(modeType)">
                                <option value="0" >--Select--</option>
                                <option [value]="1">Product</option>
                                <option [value]="2">Material</option>
                                <option [value]="3">Spare</option>
                                <option [value]="4">Assembly</option>
                            </select> -->
                        </div>
                        <!-- <span class="label darkBlueBadge-wb mrgnTop10 fntSz  {{modeType == 1 ? 'darkBlueBadge-wb-active' : ''}}"
                            (click)="changeMode('1')" style="cursor: pointer; margin-left: 0px; height: 30px">
                            <span style="margin-right: 5px">
                                <i class="fa fa-square" aria-hidden="true"></i>
                            </span> <span>Products</span>
                        </span>
                        <span class="label darkBlueBadge-wb mrgnTop10 fntSz  {{modeType == 2 ? 'darkBlueBadge-wb-active' : ''}}"
                            (click)="changeMode('2')" style="cursor: pointer; margin-left: 10px; height: 30px">
                            <span style="margin-right: 5px">
                                <i class="fa fa-square" aria-hidden="true"></i>
                            </span> <span>Materials</span>
                        </span>
                        <span class="label darkBlueBadge-wb mrgnTop10 fntSz  {{modeType == 3 ? 'darkBlueBadge-wb-active' : ''}}"
                            (click)="changeMode('3')" style="cursor: pointer; margin-left: 10px; height: 30px">
                            <i class="fa fa-square" aria-hidden="true"></i><span style="margin-left: 5px">Spares</span>
                        </span>
                        <span class="label darkBlueBadge-wb mrgnTop10 fntSz  {{modeType == 4 ? 'darkBlueBadge-wb-active' : ''}}"
                            (click)="changeMode('4')" style="cursor: pointer; margin-left: 10px; height: 30px">
                            <span style="margin-right: 5px">
                                <i class="fa fa-square" aria-hidden="true"></i>
                            </span><span>Assemblies</span>
                        </span> -->
                    </div>
                    <div class="col-md-12 col-12 col-sm-12 mobView font13" style="padding: 0px 15px; margin-bottom: 0px; margin-top: 10px;">
                        <span>
                            <mat-checkbox class="example-margin" [(ngModel)]="data.IsMade" tabindex="1">Internal Manufacturing
                            </mat-checkbox>
                        </span>
                        <span class="PurchaseLef" style="margin-left: 20px;">
                            <mat-checkbox class="example-margin" [(ngModel)]="data.IsPurchased" tabindex="1">Purchase</mat-checkbox>
                        </span>
                    </div> 

                    <div class="col-md-6 col-12 col-sm-12 inLneBlk" style="color: #2b7fb3; padding-right: 15px;">
                        <div class="label-new" style="color: #333;">Name</div><span class="redText margTop10">*</span>
                        <span class="fieldPad" style="font-weight: bold; color: #333; font-size: 17px;">
                            <mat-form-field  class="example-full-width top14 wdt font13 marginTop10Mob mT15" appearance="outline" style="width: 100%;"><!-- mat-form-field-should-float: false -->
                                <!-- <mat-label readonly>Name</mat-label> -->
                                <input matInput (ngModelChange)="getCode($event)" [(ngModel)]="data.ItemName"
                                    tabindex="1" captalize-first maxlength="100">
                            </mat-form-field>
                        </span>
                    </div>
                    <div class="{{data.ItemID == 0 ? 'col-md-6' : 'col-md-5'}} col-12 col-sm-12 inLneBlk marginTop25Mob" style="text-align: left; padding-right: 15px;">
                        <div class="label-new" style="color: #333;">Code</div><span class="redText margTop10">*</span>
                        <div style="display: flex; align-items: start; column-gap: 16px;">
                            <span class="fieldPad" style="{{isEdit ? 'width: 90%;' : 'width: 100%;'}}">
                                <!-- <input type="text" id="txtItem" class="form-control " tabindex="1" placeholder="Code"
                                        title="Item Code" [(ngModel)]="data.code" (blur)="funCodeChange()" captalize-first style=" width: 95%;" maxlength="20" />
                                -->
                                <mat-form-field class="example-full-width top14 wdt font13 mobWidth100 marginTop10Mob mT15" appearance="outline" style="width: 97%;">
                                    <!-- <mat-label>Code</mat-label> -->
                                    <input matInput tabindex="1" [(ngModel)]="data.code" (blur)="funCodeChange()"
                                        captalize-first maxlength="50">
                                </mat-form-field>  
                                <span class="PreC prevCodeMob marginTop7Mob" style="color: #777; font-size: 11px; position: relative; top: -15px; text-align: left; float: left; margin-left: {{isClosSettingShow ? '26px;' : '0px;' }}"
                                    *ngIf="prevItemCode">
                                    {{data.ItemID == 0 ? 'Prev. Code : ' + prevItemCode : ''}}
                                </span>
                            </span> 
                            <div *ngIf="data.ItemID != 0" class="col-md-1 col-1 col-sm-1 pad0 inLneBlk barcodeBtn" style="margin-top: 1px;">
                                <span class="btn-orange fntSz brdrRadius3" (click)="openBarcodeOptions(barcodeOptionsTemplate)" title="Generate barcode" style="display: inline-block; line-height: 1.5em; padding: 6px 6px 1px;">
                                  <span><i class="fa fa-barcode" style="font-size: 17px;"></i></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>    
            <div *ngIf="isERPGold == false" class="col-md-12 col-12 col-sm-12 marginTop25Mob pad0">
                <div class="col-md-3 col-12 col-sm-9 inLneBlk pad0">
                    <div class="label-new" style="color: #333;">Category</div>
                    <span class="fieldPad dspFlex" style="align-items: start;">
                        <!-- <input type="text"  list="categoryList" id="txtItem" class="form-control " tabindex="1" placeholder="Select Category"
                            title="Category" [(ngModel)]="data.category" style=" width: 95%;" (change) = "selectCategory()"/>

                            <datalist id="categoryList">
                                <option *ngFor="let a of categories" [value]="a.cnm"></option>
                            </datalist> -->
                        <mat-form-field class="example-full-width font13" style="width: 80%; margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Category</mat-label> -->
                            <input matInput (blur)="selectCategory()" tabindex="1"
                                [(ngModel)]="data.category" [matAutocomplete]="auto" [formControl]="categoryCtrl">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
                                    <span>{{x.cnm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New Category" *ngIf="rights.InvCfg" (click)="open();" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-md-3 col-12 col-sm-9 inLneBlk pad0 mL10 marginTop7Mob">
                    <div class="label-new" style="color: #333;">Sub-Category</div>
                    <span class="fieldPad">
                        <!-- <input type="text"  list="subCategoryList" id="txtItem"  [disabled]="subCategoryList.length == 0" class="form-control " tabindex="1" placeholder="Select Sub-Category"
                            title="Category" [(ngModel)]="data.subCategory" style=" width: 95%;" (change) = "selectSubCategory()"/>

                            <datalist id="subCategoryList">
                                <option *ngFor="let x of subCategoryList" [value]="x.snm"></option>
                            </datalist>
                        -->
                        <mat-form-field class="example-full-width font13"  style="width: 80%; margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Sub-Category</mat-label> -->
                            <input matInput (blur)="selectSubCategory()" tabindex="1"
                                [(ngModel)]="data.subCategory" [matAutocomplete]="autoSUb" [formControl]="subCategoryCtrl">
                            <mat-autocomplete #autoSUb="matAutocomplete">
                                <mat-option *ngFor="let x of filteredsubCategoryList | async" [value]="x.snm">
                                    <span>{{x.snm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New SubCategory" *ngIf="rights.InvCfg" (click)="openSubCat('', data.categoryID);" class="lableBtnOrange" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-12 col-md-12 col-sm-12 pad0">
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 dspFlex mT10" style="align-items: center;" *ngIf="!transactionDone"> 
                        <span class="inLneBlk qtyWidth fieldPad" style="width: 38%; margin-right: 5px;"  *ngIf="data.ItemID == 0">
                            <div class="label-new" style="color: #333;">Qty</div>
                            <!-- <input type="text" id="txtItem"
                                [disabled]="data.ItemID  != 0" class="form-control txtRight" tabindex="1" placeholder="Qty"
                                title="Qty" (change)="enterQty()" (keypress)="CmnService.numberOnly($event)"
                                [(ngModel)]="data.Qty" /> -->
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                    (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.Qty" captalize-first
                                    maxlength="20">
                            </mat-form-field>
                        </span>
                        <span class="inLneBlk nosWid fieldPad mL10-alt" style="width: 37%;" *ngIf="!transactionDone"> <!-- data.ItemID == 0-->
                            <div class="label-new" style="color: #333;">Unit</div>
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                    [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                                <mat-autocomplete #autoUnit="matAutocomplete">
                                    <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                        <span>{{x.UNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10 mL10" *ngIf="data.ItemID == 0">
                        <div class="label-new" style="display: block; color: #333; padding-bottom: 3px;">Store</div>
                        <span class="fieldPad dspFlex" style="align-items: baseline;">
                            <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.storeName" tabindex="1"
                                placeholder="Select Store" list="storeList" title="Store" captalize-first style=" width: 100%;"
                                (change)="selectStore()" />
                            <datalist id="storeList">
                                <option *ngFor="let x of storeList" [value]="x.sNm"></option>
                            </datalist> -->
                            <mat-form-field class="example-full-width font13" [style.width]="isMobileView ? '100%' : '80%'" appearance="outline">
                                <input matInput (blur)="selectStore()" tabindex="1"
                                    [(ngModel)]="data.storeName" [matAutocomplete]="autoStore" [formControl]="StoreCtrl">
                                <mat-autocomplete #autoStore="matAutocomplete">
                                    <mat-option *ngFor="let x of filterStore | async" [value]="x.sNm">
                                        <span>{{x.sNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <span class="lableBtnOrange" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="openStore()" title="Add New Store">
                                <i class="zmdi zmdi-plus"></i>
                            </span>
    
                            <!-- <span class="btn btn-orange fntSz" (click)="openStore();" title="dd Store"
                                style="cursor: pointer; margin-left: 10px; line-height: 23px; padding: 4px 8px; font-size: 17px; display:none">
                                <span>
                                    <i class="zmdi zmdi-store" aria-hidden="true"></i>
                                </span>
                            </span> -->
                        </span>
                    </div>
                </div>
            </div>
            <!-- isERPGOLD == true category , subcategory, batchtype -->
            <div *ngIf="isERPGold == true" class="col-md-9 col-12 col-sm-12 marginTop25Mob pad0" style="float: left;">
                <div class="col-md-4 col-12 col-sm-6 inLneBlk pad0">
                    <div class="label-new" style="color: #333;">Category</div>
                    <span class="fieldPad dspFlex" style="align-items: start;">
                        <mat-form-field class="example-full-width textboxWidth font13 width" style="margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Category</mat-label> -->
                            <input matInput (blur)="selectCategory()" tabindex="1"
                                [(ngModel)]="data.category" [matAutocomplete]="auto" [formControl]="categoryCtrl">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
                                    <span>{{x.cnm}} </span>
                                </mat-option> 
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New Category" *ngIf="rights.InvCfg" (click)="open();" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-md-4 col-12 col-sm-5 inLneBlk pad0 mL10 mT10">
                    <div class="label-new" style="color: #333;">Sub-Category</div>
                    <span class="fieldPad dspFlex">
                         <mat-form-field class="example-full-width textboxWidth font13 width"  style="margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Sub-Category</mat-label> -->
                            <input matInput  (blur)="selectSubCategory()" tabindex="1"
                                [(ngModel)]="data.subCategory" [matAutocomplete]="autoSUb" [formControl]="subCategoryCtrl">
                            <mat-autocomplete #autoSUb="matAutocomplete">
                                <mat-option *ngFor="let x of filteredsubCategoryList | async" [value]="x.snm">
                                    <span>{{x.snm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New SubCategory" *ngIf="rights.InvCfg" (click)="openSubCat('', data.categoryID);" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
            </div>

            <!--Expand & collapse-->
            <div class="pad0" (click)="collapseDiv()" style="cursor: pointer; margin-top: 0px; display: flex; gap: 5px; align-items: center; margin-bottom: 40px; padding-right: 10px;">
                <i class="fa fa-angle-down icon transtition-arrow {{expand.extraDetails ? 'transform-arrow' : ''}}" style="font-size: 18px; margin-left: 5px;"> </i>
                <span style="font-size: 13px; ">Enter more details</span>
            </div>

            <div class="col-md-12 col-xs-12 col-sm-12 pad0" *ngIf="expand.extraDetails">
                <div *ngIf="isERPGold == true" class="col-md-3 col-xs-12 col-sm-12 marginTop25Mob pad0 floatRight">
                    <div class="dspFlex dspInline mL200" style="display: inline;">
                        <div *ngIf="isERPGoldBatches" class="col-md-12 col-6 col-sm-6 inLneBlk pad0 mL10 mT10 wid75">
                            <!-- Batch Type -->
                            <div class="label-new" style="color: #333;">Batch</div>
                            <span *ngIf="!isEdit" class="inLneBlk nosWid fieldPad" style="margin-left: 0px;" [style.width]="isMobileView ? '100%' : '95%'">
                                <mat-form-field class="example-full-width wdt font13" appearance="outline">
                                    <input matInput placeholder="Batch Type"  (blur)="getBatchType()" tabindex="1" [(ngModel)]="data.batchType"
                                        [matAutocomplete]="autoBatch" [formControl]="batchCtrl">
                                    <mat-autocomplete #autoBatch="matAutocomplete" >
                                        <mat-option *ngFor="let x of batchType" [value]="x.type">
                                            <span>{{x.type}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field class="example-full-width wdt font13" *ngIf="isEdit" appearance="outline">
                                    <input matInput placeholder="Batch Type"  tabindex="1" [(ngModel)]="data.batchType" >
                                </mat-form-field>
                            </span>
                             <!-- Batch Type -->
                             <span *ngIf="isEdit" class="inLneBlk nosWid fieldPad" style="margin-left: 0px;width: 100%; cursor: not-allowed;">
                                <mat-form-field class="example-full-width wdt font13" *ngIf="isEdit" appearance="outline">
                                    <input matInput placeholder="Batch Type"  tabindex="1" [(ngModel)]="data.batchType"  [disabled]="isEdit" style="cursor: not-allowed; color: #777;">
                                </mat-form-field>
                            </span>
                        </div>
                        <div class="col-md-12 col-6 col-sm-6 inLneBlk pad0 mrginrightIMPItm mT10 mobView mL10-alt impDiv" *ngIf="!isEdit" style="display: inline-block;">
                            <!-- Important -->
                            <div class="label-new" style="color: #333;">Importance</div>
                            <span class="inLneBlk nosWid fieldPad"  style="width: 94%;">
                                <mat-form-field class="example-full-width wdt font13" appearance="outline">
                                    <!-- <mat-label>Importance</mat-label> -->
                                    <input matInput tabindex="1" [(ngModel)]="data.IMPTtemTyp"
                                        [matAutocomplete]="autoItemIMP" [formControl]="impItemCtrl">
                                    <mat-autocomplete #autoItemIMP="matAutocomplete">
                                        <mat-option *ngFor="let x of itemImportant" [value]="x.itemType">
                                            <span>{{x.itemType}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </span>
                        </div>
                        <div class="col-md-12 col-xs-5 col-sm-5 inLneBlk pad0 mrginrightIMPItm mT10 impDiv" *ngIf="isEdit" style="margin-left: 10px;">
                            <!-- Important -->
                            <div class="label-new" style="color: #333;">Importance</div>
                            <span class="inLneBlk nosWid fieldPad"  style="width: 82%;">
                                <mat-form-field class="example-full-width wdt font13" appearance="outline">
                                    <input matInput placeholder="Importance"  (blur)="getIMPItems()" tabindex="1" [(ngModel)]="data.IMPTtemTyp"
                                        [matAutocomplete]="autoItemIMP" [formControl]="impItemCtrl">
                                    <mat-autocomplete #autoItemIMP="matAutocomplete" >
                                        <mat-option *ngFor="let x of itemImportant" [value]="x.itemType">
                                            <span>{{x.itemType}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-2 col-4 col-sm-4 inLneBlk pad0 editunt" *ngIf="isEdit && !transactionDone">
                        <div class="label-new" style="color: #333;">Unit</div>
                        <span class="inLneBlk nosWid fieldPad" *ngIf="!transactionDone" > <!-- data.ItemID == 0-->
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                    [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                                <mat-autocomplete #autoUnit="matAutocomplete">
                                    <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                        <span>{{x.UNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <!-- <div class="col-md-2 col-4 col-sm-4 inLneBlk pad0">
                     <span *ngIf="isERPGold && data.ItemID != 0" class="orangeBadge label yellowBadge mrgnTop10 fntSz brdrRadius3" (click)="uploadBiziFile()"  style="margin:0px 0px;padding: 4px 8px; cursor: pointer;">
                        <i class = "{{hasImg ? 'fa fa-pencil' : 'zmdi zmdi-plus'}}" style="padding-right: 2px;"></i>                  
                        <span style="margin-left:4px;">Image</span>
                    </span>
                    </div> -->
                </div>
                
                <div *ngIf="isERPGold == true" class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 dspFlex mT10" style="align-items: center;" *ngIf="!transactionDone">
                        <span class="inLneBlk qtyWidth fieldPad width50" style="width: 38%;" [style.width]="!isMobileView ? '38%' : ''" *ngIf="data.ItemID == 0">
                            <div class="label-new" style="color: #333;">Qty</div>
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <!-- <mat-label>Qty</mat-label> -->
                                <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                    (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.Qty" captalize-first
                                    maxlength="20">
                            </mat-form-field>
                        </span>
                        <span class="inLneBlk nosWid fieldPad width50 mL10-alt" style="width: 37%;" *ngIf="!transactionDone && !isEdit" > <!-- data.ItemID == 0-->
                            <div class="label-new" style="color: #333;">Unit</div>
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                    [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                                <mat-autocomplete #autoUnit="matAutocomplete">
                                    <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                        <span>{{x.UNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10 mL10"  *ngIf="data.ItemID == 0">
                        <div class="label-new" style="display: block; color: #333; padding-bottom: 3px;">Store</div>
                        <span class="fieldPad dspFlex" style="align-items: baseline;">
                            <mat-form-field class="example-full-width font13" [style.width]="isMobileView ? '100%' : '80%'" appearance="outline">
                                <!-- <mat-label>Store</mat-label> -->
                                <input matInput (blur)="selectStore()" tabindex="1"
                                    [(ngModel)]="data.storeName" [matAutocomplete]="autoStore" [formControl]="StoreCtrl">
                                <mat-autocomplete #autoStore="matAutocomplete">
                                    <mat-option *ngFor="let x of filterStore | async" [value]="x.sNm">
                                        <span>{{x.sNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <span class="lableBtnOrange" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="openStore()" title="Add New Store">
                                <i class="zmdi zmdi-plus"></i>
                            </span>
                            <!-- <span class="btn btn-orange fntSz" (click)="openStore();" title="dd Store"
                                style="cursor: pointer; margin-left: 10px; line-height: 23px; padding: 4px 8px; font-size: 17px; display:none">
                                <span>
                                    <i class="zmdi zmdi-store" aria-hidden="true"></i>
                                </span>
                            </span> -->
                        </span>
                    </div>                
                    <div class="col-md-3 col-4 col-sm-4 inLneBlk pad0" *ngIf="isExpirableBatch && isShowBatch">
                        <span class="label orangeBadge mrgnTop10 fntSz brdrRadius3"
                        (click)="openBatchSelectionMdl()" style="cursor: pointer; margin-left: 15px;">
                        <span style="margin-right: 5px">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </span> <span>Batches</span>
                        </span>
                    </div>
                </div>
                          
                <div *ngIf="isRateView" class="col-md-12 col-sm-12 col-12 pad0 mrgntp8 mobView" style="text-align: left;">
                    <div class="col-md-4 col-sm-12 col-12 inLneBlk font13 pad0">
                        <div class="label-new">Std. Cost</div>
                        <div class="inrAlignMob">
                            <span class="inLneBlk">
                                <!-- <i class="zmdi zmdi-widgets" style="color: #2b7fb3;"></i> -->
                                <span class="iconBox inrIconMob">
                                    {{myCurrency.symbol ? myCurrency.symbol : '₹'}}
                                </span>
                            </span>
                            <span class="inLneBlk fieldPad floatLeftMob">
                                <mat-form-field class="example-full-width wdh50 width130" style="width: 110px; text-align: right" appearance="outline">
                                    <!-- <mat-label>Std Cost</mat-label> -->
                                    <input class="iconField" matInput tabindex="1" [(ngModel)]="data.stockRate"
                                        (ngModelChange)="changeStockRate($event)" captalize-first maxlength="10"
                                        (keypress)="CmnService.numberOnly($event)" (blur)="enterStockRate();">
                                </mat-form-field>
                            </span>
                            <span class="font13">/ {{data.Unit}}</span>
                       </div>
                    </div>
                    <div  class="col-md-4 col-sm-12 col-xs-12 inLneBlk font13 pad0">
                        <div class="label-new">
                            Purch Cost
                        </div>
    
                      <div class="inrAlignMob">
                        <span class="inLneBlk">
                            <!-- <i class="fa fa-shopping-cart" style="color: #4caf50;"></i> -->
                            <span class="iconBox inrIconMob" >
                                {{myCurrency.symbol ? myCurrency.symbol : '₹'}}
                            </span> 
                        </span>
                        <span class="inLneBlk fieldPad floatLeftMob">
                            <mat-form-field class="example-full-width wdh50 width130" style="width: 112px; text-align: right" appearance="outline">
                                <!-- <mat-label>Purch Cost</mat-label> -->
                                <input matInput tabindex="1" [(ngModel)]="data.purchaseCost" captalize-first maxlength="10"
                                    (keypress)="CmnService.numberOnly($event)" (blur)="enterStockRate();">
                            </mat-form-field>
                        </span>
                        <span class="font13">
                            / {{data.Unit}}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12 inLneBlk font13 pad0">
                        <div class="label-new">
                            Std Sale Price
                        </div>
                      
                        <div class="inrAlignMob">
                        <span class="inLneBlk">
                            <!-- <i class="zmdi zmdi-money-box" style="color: #e88421;"></i> -->
                            <span class="iconBox inrIconMob">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span> 
                        </span>
                        <span class="inLneBlk fieldPad floatLeftMob">
                            <mat-form-field class="example-full-width wdh50 width130" style="width: 108px; text-align: right" appearance="outline">
                                <!-- <mat-label>Std Sale Price</mat-label> -->
                                <input matInput tabindex="1" [(ngModel)]="data.salePrice" (ngModelChange)="fn_changeMRPRate($event)"  captalize-first maxlength="15"
                                    (keypress)="CmnService.numberOnly($event)" (blur)="enterStockRate();">
                            </mat-form-field>
                        </span>
                        <span class="font13">
                            / {{data.Unit}}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-12 col-xs-12 inLneBlk font13 pad0" *ngIf="isShowCatWiseRateBtn" style="margin-bottom: 15px;">
                        <span class="inLneBlk label darkBlueBadge fntSz font13 overFlowHidden brdrRadius3" style="cursor: pointer;" (click)="openCategoryWiseRateMdl(categoryRate);">
                            <div style="display: inline-flex; justify-content: space-between; align-items: center; column-gap: 4px;">
                                <i class = "fa fa-sitemap" style="padding-right: 2px;"></i>
                                <span>Customer Category-wise Rates</span>
                            </div>
                        </span>
                    </div>
                </div>
    
                <div class="col-md-12 col-sm-12 col-12 {{enableMRP ? 'mT0' : ''}} pad0" style="text-align: left;">
                    <div class="col-md-12 col-sm-12 col-12 pad0 mrgntp8">
                        <div class="col-md-6 col-sm-6 col-12 pad0" style="display: inline-block;">
                            <div class="label-new" style="color: #333;">Description (will be suggested in documents like invoices, orders, etc.)</div>
                            <!-- <textarea type="text" title="Description"
                                placeholder="Description (will be suggested in documents like invoices, orders, etc.)"
                                class="form-control brdrColor"
                                style="white-space: pre-line; border: 1px solid #ddd !important ; resize: none; border-radius: 10px !important; padding: 10px;"
                                rows="2" [(ngModel)]="data.description" maxlength="200" captalize-first tabindex="1"></textarea> -->
                            <mat-form-field out class="example-full-width myText font13 notes" appearance="outline"
                                style="width: 100%; padding-bottom: 10px;">
                                <!-- <mat-label>Description (will be suggested in documents like invoices, orders, etc.)</mat-label> -->
                                <textarea matInput rows="2" style="resize: none;" [(ngModel)]="data.description" maxlength="1000"
                                    tabindex="1"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 padd0 mT10" style="display: inline-block;">
                            <div class="label-new" style="color: #333;">Internal Notes</div>
                            <mat-form-field out class="example-full-width myText font13 notes" appearance="outline"
                                style="width: 100%; padding-bottom: 10px;">
                                <!-- <mat-label>Internal Notes</mat-label> -->
                                <textarea matInput rows="2" style="resize: none;" [(ngModel)]="data.internalNotes"
                                    maxlength="200" tabindex="1"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div *ngIf="isIndian && !enableMRP" class="col-md-2 col-6 col-sm-6 inLneBlk pad0">
                        <span class="inLneBlk fieldPad">
                            <div class="label-new" style="color: #333;">HSN/SAC</div>
                            <mat-form-field class="example-full-width font13" style="width: 75%;" appearance="outline">
                                <input matInput (blur)="selectHSN()" tabindex="1"
                                    [(ngModel)]="data.HSN" [matAutocomplete]="autoHSn" [formControl]="HSNCtrl">
                                <mat-autocomplete #autoHSn="matAutocomplete">
                                    <mat-option *ngFor="let x of filterHSN | async" [value]="x.H">
                                        <span>{{x.H}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                    </div>
                    <div *ngIf="isIndian && !enableMRP" class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mL40">
                        <span class="inLneBlk font13 fieldPad" style="width: 65%;">
                            <div style="display: block;">
                                <div class="label-new" style="color: #333; padding-bottom: 0px;">GST</div>
                            </div>
                            <mat-form-field class="example-full-width wdh50" style="width: 60%; text-align: right" appearance="outline">
                                <!-- <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="2" [disabled]="IsDisable"
                                    placeholder="GST" (keypress)="CmnService.numberOnly($event)"> -->
                                    <!-- <mat-label>GST</mat-label> -->
                                <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="4"
                                    (keypress)="CmnService.numberOnly($event)" 
                                    (blur)="calMrpGST();">
                            </mat-form-field>
                            %
                        </span>
                    </div>
                    <div *ngIf="isIndian && enableMRP" class="col-md-4 col-xs-12 col-sm-12 inLneBlk pad0 mobView mT10">
                        <span class="inLneBlk fieldPad" style="width: 50%;">
                            <div class="label-new">HSN/SAC</div>
                            <mat-form-field class="example-full-width font13" style="width: 80%;" appearance="outline">
                                <input matInput  (blur)="selectHSN()" tabindex="1"
                                    [(ngModel)]="data.HSN" [matAutocomplete]="autoHSn" [formControl]="HSNCtrl">
                                <mat-autocomplete #autoHSn="matAutocomplete">
                                    <mat-option *ngFor="let x of filterHSN | async" [value]="x.H">
                                        <span>{{x.H}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="inLneBlk font13 fieldPad" style="width: 50%;">
                            <div class="label-new" style="color: #333; display: block;">GST</div>
                            <mat-form-field class="example-full-width wdh50 " style="width: 60%; text-align: right" appearance="outline">
                                <!-- <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="2" [disabled]="IsDisable"
                                    placeholder="GST" (keypress)="CmnService.numberOnly($event)"> -->
                                <!-- <mat-label>GST</mat-label> -->
                                <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="4"
                                     (keypress)="CmnService.numberOnly($event)" 
                                    (blur)="fn_gstCount();">
                            </mat-form-field>
                            %
                        </span>
                    </div>
                    <div class="mobView mT10">
                        <span *ngIf="enableMRP" class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mrgnLft0 font13">
                            <span class="label-new" style="color: #333; padding-bottom: 0px;">Price Incl. Tax</span>
                            <div>
                                <span class="inLneBlk">
                                    <span style="margin-left: 5px;"></span>
                                    <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                                </span>
                                <span class="inLneBlk fieldPad" style="width: 115px;">
                                    <mat-form-field class="example-full-width wdh50 font13" style="width: 135px; text-align: right; left: -25px;" appearance="outline">
                                        <input class="iconField" matInput tabindex="1" [(ngModel)]="data.mrpRate" (ngModelChange)="revCalculateMRP()" maxlength="7"
                                            (keypress)="CmnService.numberOnly($event)">
                                    </mat-form-field>
                                </span>
                                <span class="font12">/ {{data.Unit}}</span>
                            </div>
                        </span>
                    </div>
                    <!-- MRP Price -->
                    <div class="mobView mT10">
                        <span *ngIf="isB2C" class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mrgnLft0 font13">
                            <span class="label-new" style="color: #333; padding-bottom: 0px;">MRP</span>
                            <div>
                                <span class="inLneBlk">
                                    <span style="margin-left: 5px;"></span>
                                    <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                                </span>
                                <span class="inLneBlk fieldPad" style="width: 115px;">
                                    <mat-form-field class="example-full-width wdh50 font13" style="width: 135px; text-align: right; left: -25px;" appearance="outline">
                                        <input class="iconField" matInput tabindex="1" [(ngModel)]="data.mrpPrice" maxlength="7"
                                            (keypress)="CmnService.numberOnly($event)">
                                    </mat-form-field>
                                </span>
                                <span class="font12">/ {{data.Unit}}</span>
                            </div>
                        </span>
                    </div>
                    <div class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mrgnLft0 font13" style="margin-left: {{isIndian ? '0px' : ''}};">
                        <span class="inLneBlk fieldPad" style="width: 60%;">
                            <div class="label-new" style="color: #333;">Min Stock</div>
                            <!-- <input type="text" id="txtItem " class="form-control " tabindex="1" placeholder="Min Level Qty"
                                title="minimum Stock Qty" [(ngModel)]="data.minStockQty" style="text-align: right;" /> -->
                            <mat-form-field class="example-full-width" style="width: 90%;" appearance="outline">
                                <!-- <mat-label>Min Stock</mat-label> -->
                                <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                    (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.minStockQty" maxlength="7">
                            </mat-form-field>
                        </span>
                        <span class="font12" style="margin-left: -10px;">
                            {{data.Unit}}
                        </span>
                    </div>
                    <div class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mrgnLft0" style="margin-left: 10px;">
                        <div class="label-new" style="color: #333;">Lead Time</div>
                        <span class="Left0 fieldPad">
                            <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.leadTime" tabindex="1"
                                placeholder="Lead Time" title="Lead Time" captalize-first style=" width: 75%;text-align: right;"
                                (keypress)="CmnService.numberOnly($event)" /> -->
    
                            <mat-form-field class="example-full-width font13" style="width: 75%;" appearance="outline">
                                <!-- <mat-label>Lead Time</mat-label> -->
                                <input matInput tabindex="1" class="txtRight" (keypress)="CmnService.numberOnly($event)"
                                    [(ngModel)]="data.leadTime" maxlength="3">
                            </mat-form-field>
                            <span style="font-size: 13px;"> {{ data.leadTime == 1 ? 'day' : 'days' }}</span>
                        </span>
                        <!-- <span style="margin-left: 20px;">
                            <mat-checkbox class="example-margin" [(ngModel)]="data.IsMade">Internal Manufacturing</mat-checkbox>
                        </span>
                        <span style="margin-left: 20px;">
                            <mat-checkbox class="example-margin" [(ngModel)]="data.IsPurchased">Purchase</mat-checkbox>
                        </span> -->
                    </div>
                </div>
                 
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10">
                        <div class="label-new" style="color: #333; display: block;">Tags</div>
                        <span class="fieldPad">
                            <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.tag" tabindex="1"
                                (ngModelChange)="chagetagValue()" placeholder="Enter Tag" title="Tag" captalize-first
                                style=" width: 100%;" (change)="tagEntry()" /> -->
                            <!-- <mat-form-field class="example-full-width" style="width: 90%;">
                                <mat-label>Enter Tag</mat-label>
                                <input matInput tabindex="1" [(ngModel)]="data.tag" maxlength="20">
                            </mat-form-field> -->
                            <mat-form-field class="example-full-width Wid87 font13" style="width: 60%;" appearance="outline">
                                <!-- <mat-label>Tags</mat-label> -->
                                <input matInput tabindex="1" maxlength="20" [(ngModel)]="data.tag"
                                    [matAutocomplete]="autoTag" [formControl]="TagCtrl">
                                <mat-autocomplete #autoTag="matAutocomplete">
                                    <mat-option *ngFor="let x of filterTag | async" [value]="x.Tnm">
                                        <span>{{x.Tnm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="lableBtnOrange" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="tagEntry()">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <div class="col-md-9 col-sm-12 col-12 inLneBlk mrgntp8 pad0 mT40 mT10" style="text-align: left;">
                        <div class="TagLeft0 brdrRadius3" style="display: inline-block; border: 1px solid #ddd; padding: 3px 9px; margin-top: 5px; margin-left: 5px; background: #f0f0f0 !important; color: #333; font-size: 14px;"
                            *ngFor="let x of tagList; let i = index">
                            <span>
                                {{x}}
                            </span>
                            <span style="margin-left: 10px; cursor: pointer;" (click)="removeTagSearch(i)">
                                <i class="zmdi zmdi-close"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Save -->
            <div class="col-md-12 col-12 col-sm-12 mT20Mob pad0">
                <div class="col-md-4 col-12 col-sm-6 inLneBlk pad0" style="font-size: 13px; display: flex; gap: 10px;">
                    <span class="btn-darkGreen ng-scope brdrRadius3" style="padding: 2px 7px 1px; height: 30px;" (click)="save()">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>
                        {{data.ItemID == 0 ? 'Save' : 'Update'}}
                    </span>
                    <span *ngIf="!showAsPage" class="darkBlueButton mobView" style="display: inline-block; height: 30px; padding: 6px 9px 1px !important;" (click)="closeModel()">
                        <i class="fa fa-close" style="margin-right: 5px;"></i>Close
                    </span>
                    <span *ngIf="showAsPage" class="btn darkBlueButton" (click)="backToHomeBtn()">
                        <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                    </span>
                </div>
            </div>
        </div>
        <!-- Web View -->
        <div class="{{isClosSettingShow ? 'modal-body' : ''}} webView" style="{{isClosSettingShow ? 'padding-left: 5px;' : ''}}">    
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="row">
                    <div class="col-md-6 col-12 col-sm-12 inLneBlk marginTop10Mob" style="color: #2b7fb3; padding-right: 15px;">
                        <div class="label-new" style="color: #333;">Name</div><span class="redText margTop10">*</span>
                        <span class="fieldPad" style="font-weight: bold; color: #333; font-size: 17px;">
                            
                            <mat-form-field  class="example-full-width top14 wdt font13 marginTop10Mob mT15" appearance="outline" style="width: 100%;"><!-- mat-form-field-should-float: false -->
                                <!-- <mat-label readonly>Name</mat-label> -->
                                <input matInput (ngModelChange)="getCode($event)" [(ngModel)]="data.ItemName"
                                    tabindex="1" captalize-first maxlength="100">
                            </mat-form-field>

                        </span>
                    </div>
                    <div class="{{data.ItemID == 0 ? 'col-md-6' : 'col-md-5'}} col-12 col-sm-12 inLneBlk marginTop25Mob" style="text-align: left; padding-right: 15px;">
                        <div class="label-new" style="color: #333;">Code</div><span class="redText margTop10">*</span>
                        <div style="display: flex; align-items: start; column-gap: 16px;">
                            <span class="fieldPad" style="{{isEdit ? 'width: 90%;' : 'width: 100%;'}}">
                                <!-- <input type="text" id="txtItem" class="form-control " tabindex="1" placeholder="Code"
                                        title="Item Code" [(ngModel)]="data.code" (blur)="funCodeChange()" captalize-first style=" width: 95%;" maxlength="20" />
                                -->
                                <mat-form-field class="example-full-width top14 wdt font13 mobWidth100 marginTop10Mob mT15" appearance="outline" style="width: 97%;">
                                    <!-- <mat-label>Code</mat-label> -->
                                    <input matInput tabindex="1" [(ngModel)]="data.code" (blur)="funCodeChange()"
                                        captalize-first maxlength="50">
                                </mat-form-field>  
                                <span class="PreC prevCodeMob marginTop7Mob" style="color: #777; font-size: 11px; position: relative; top: -15px; text-align: left; float: left; margin-left: {{isClosSettingShow ? '26px;' : '0px;' }}"
                                    *ngIf="prevItemCode">
                                    {{data.ItemID == 0 ? 'Prev. Code : ' + prevItemCode : ''}}
                                </span>
                            </span>
                            <div *ngIf="data.ItemID != 0" class="col-md-1 col-1 col-sm-1 pad0 inLneBlk barcodeBtn" style="margin-top: 1px;">
                                <span class="btn-orange fntSz brdrRadius3" (click)="openBarcodeOptions(barcodeOptionsTemplate)" title="Generate barcode" style="display: inline-block; line-height: 1.5em; padding: 6px 6px 1px;">
                                  <span><i class="fa fa-barcode" style="font-size: 17px;"></i></span>
                                </span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>    
            <div *ngIf="isERPGold == false" class="col-md-12 col-12 col-sm-12 marginTop25Mob pad0">
                <div class="col-md-3 col-12 col-sm-9 inLneBlk pad0">
                    <div class="label-new" style="color: #333;">Category</div>
                    <span class="fieldPad dspFlex" style="align-items: start;">
                        <!-- <input type="text"  list="categoryList" id="txtItem" class="form-control " tabindex="1" placeholder="Select Category"
                            title="Category" [(ngModel)]="data.category" style=" width: 95%;" (change) = "selectCategory()"/>

                            <datalist id="categoryList">
                                <option *ngFor="let a of categories" [value]="a.cnm"></option>
                            </datalist> -->
                        <mat-form-field class="example-full-width font13" style="width: 80%; margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Category</mat-label> -->
                            <input matInput (blur)="selectCategory()" tabindex="1"
                                [(ngModel)]="data.category" [matAutocomplete]="auto" [formControl]="categoryCtrl">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
                                    <span>{{x.cnm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New Category" *ngIf="rights.InvCfg" (click)="open();" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-md-3 col-12 col-sm-9 inLneBlk pad0 mL10 marginTop7Mob">
                    <div class="label-new" style="color: #333;">Sub-Category</div>
                    <span class="fieldPad">
                        <!-- <input type="text"  list="subCategoryList" id="txtItem"  [disabled]="subCategoryList.length == 0" class="form-control " tabindex="1" placeholder="Select Sub-Category"
                            title="Category" [(ngModel)]="data.subCategory" style=" width: 95%;" (change) = "selectSubCategory()"/>

                            <datalist id="subCategoryList">
                                <option *ngFor="let x of subCategoryList" [value]="x.snm"></option>
                            </datalist>
                        -->
                        <mat-form-field class="example-full-width font13"  style="width: 80%; margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Sub-Category</mat-label> -->
                            <input matInput (blur)="selectSubCategory()" tabindex="1"
                                [(ngModel)]="data.subCategory" [matAutocomplete]="autoSUb" [formControl]="subCategoryCtrl">
                            <mat-autocomplete #autoSUb="matAutocomplete">
                                <mat-option *ngFor="let x of filteredsubCategoryList | async" [value]="x.snm">
                                    <span>{{x.snm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New SubCategory" *ngIf="rights.InvCfg" (click)="openSubCat('', data.categoryID);" class="lableBtnOrange" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-12 col-md-12 col-sm-12 pad0">
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 dspFlex mT10" style="align-items: center;" *ngIf="!transactionDone"> 
                        <span class="inLneBlk qtyWidth fieldPad" style="width: 38%; margin-right: 5px;"  *ngIf="data.ItemID == 0">
                            <div class="label-new" style="color: #333;">Qty</div>
                            <!-- <input type="text" id="txtItem"
                                [disabled]="data.ItemID  != 0" class="form-control txtRight" tabindex="1" placeholder="Qty"
                                title="Qty" (change)="enterQty()" (keypress)="CmnService.numberOnly($event)"
                                [(ngModel)]="data.Qty" /> -->
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                    (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.Qty" captalize-first
                                    maxlength="20">
                            </mat-form-field>
                        </span>
                        <span class="inLneBlk nosWid fieldPad mL10-alt" style="width: 37%;" *ngIf="!transactionDone"> <!-- data.ItemID == 0-->
                            <div class="label-new" style="color: #333;">Unit</div>
                            <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                                <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                    [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                                <mat-autocomplete #autoUnit="matAutocomplete">
                                    <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                        <span>{{x.UNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10 mL10" *ngIf="data.ItemID == 0">
                        <div class="label-new" style="display: block; color: #333; padding-bottom: 3px;">Store</div>
                        <span class="fieldPad dspFlex" style="align-items: baseline;">
                            <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.storeName" tabindex="1"
                                placeholder="Select Store" list="storeList" title="Store" captalize-first style=" width: 100%;"
                                (change)="selectStore()" />
                            <datalist id="storeList">
                                <option *ngFor="let x of storeList" [value]="x.sNm"></option>
                            </datalist> -->
                            <mat-form-field class="example-full-width font13" [style.width]="isMobileView ? '100%' : '80%'" appearance="outline">
                                <input matInput (blur)="selectStore()" tabindex="1"
                                    [(ngModel)]="data.storeName" [matAutocomplete]="autoStore" [formControl]="StoreCtrl">
                                <mat-autocomplete #autoStore="matAutocomplete">
                                    <mat-option *ngFor="let x of filterStore | async" [value]="x.sNm">
                                        <span>{{x.sNm}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <span class="lableBtnOrange" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="openStore()" title="Add New Store">
                                <i class="zmdi zmdi-plus"></i>
                            </span>
    
                            <!-- <span class="btn btn-orange fntSz" (click)="openStore();" title="dd Store"
                                style="cursor: pointer; margin-left: 10px; line-height: 23px; padding: 4px 8px; font-size: 17px; display:none">
                                <span>
                                    <i class="zmdi zmdi-store" aria-hidden="true"></i>
                                </span>
                            </span> -->
                        </span>
                    </div>
                </div>
            </div>
            <!-- isERPGOLD == true category , subcategory, batchtype -->
            <div *ngIf="isERPGold == true" class="col-md-12 col-12 col-sm-12 marginTop25Mob pad0">
                <div class="col-md-3 col-12 col-sm-6 inLneBlk pad0">
                    <div class="label-new" style="color: #333;">Category</div>
                    <span class="fieldPad dspFlex" style="align-items: start;">
                        <mat-form-field class="example-full-width textboxWidth font13 width" style="margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Category</mat-label> -->
                            <input matInput (blur)="selectCategory()" tabindex="1"
                                [(ngModel)]="data.category" [matAutocomplete]="auto" [formControl]="categoryCtrl">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let x of filteredCategory | async" [value]="x.cnm">
                                    <span>{{x.cnm}} </span>
                                </mat-option> 
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New Category" *ngIf="rights.InvCfg" (click)="open();" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="col-md-3 col-12 col-sm-5 inLneBlk pad0 mL10 mT10">
                    <div class="label-new" style="color: #333;">Sub-Category</div>
                    <span class="fieldPad dspFlex">
                         <mat-form-field class="example-full-width textboxWidth font13 width"  style="margin-right: 5px;" appearance="outline">
                            <!-- <mat-label>Sub-Category</mat-label> -->
                            <input matInput  (blur)="selectSubCategory()" tabindex="1"
                                [(ngModel)]="data.subCategory" [matAutocomplete]="autoSUb" [formControl]="subCategoryCtrl">
                            <mat-autocomplete #autoSUb="matAutocomplete">
                                <mat-option *ngFor="let x of filteredsubCategoryList | async" [value]="x.snm">
                                    <span>{{x.snm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span title="Add New SubCategory" *ngIf="rights.InvCfg" (click)="openSubCat('', data.categoryID);" class="lableBtnOrange height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </span>
                </div>
                <div class="dspFlex dspInline">
                    <div *ngIf="isERPGoldBatches" class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mL10 mT10" style="width:75%;">
                        <!-- Batch Type -->
                        <div class="label-new" style="color: #333;">Batch</div>
                        <span *ngIf="!isEdit" class="inLneBlk nosWid fieldPad" style="margin-left: 0px;" [style.width]="isMobileView ? '100%' : '95%'">
                            <mat-form-field class="example-full-width wdt font13" appearance="outline">
                                <input matInput placeholder="Batch Type"  (blur)="getBatchType()" tabindex="1" [(ngModel)]="data.batchType"
                                    [matAutocomplete]="autoBatch" [formControl]="batchCtrl">
                                <mat-autocomplete #autoBatch="matAutocomplete" >
                                    <mat-option *ngFor="let x of batchType" [value]="x.type">
                                        <span>{{x.type}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <mat-form-field class="example-full-width wdt font13" *ngIf="isEdit" appearance="outline">
                                <input matInput placeholder="Batch Type"  tabindex="1" [(ngModel)]="data.batchType" >
                            </mat-form-field>
                        </span>
                         <!-- Batch Type -->
                         <span *ngIf="isEdit" class="inLneBlk nosWid fieldPad" style="margin-left: 0px;width: 100%; cursor: not-allowed;">
                            <mat-form-field class="example-full-width wdt font13" *ngIf="isEdit" appearance="outline">
                                <input matInput placeholder="Batch Type"  tabindex="1" [(ngModel)]="data.batchType"  [disabled]="isEdit" style="cursor: not-allowed; color: #777;">
                            </mat-form-field>
                        </span>
                    </div>
                    <div class="col-md-2 col-xs-5 col-sm-5 inLneBlk pad0 mrginrightIMPItm mT10" *ngIf="isEdit" style="margin-left: 10px;">
                        <!-- Important -->
                        <div class="label-new" style="color: #333;">Importance</div>
                        <span class="inLneBlk nosWid fieldPad"  style="width: 82%;">
                            <mat-form-field class="example-full-width wdt font13" appearance="outline">
                                <input matInput placeholder="Importance"  (blur)="getIMPItems()" tabindex="1" [(ngModel)]="data.IMPTtemTyp"
                                    [matAutocomplete]="autoItemIMP" [formControl]="impItemCtrl">
                                <mat-autocomplete #autoItemIMP="matAutocomplete" >
                                    <mat-option *ngFor="let x of itemImportant" [value]="x.itemType">
                                        <span>{{x.itemType}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                    </div>
                </div>
                <div class="col-md-2 col-4 col-sm-4 inLneBlk pad0 editunt" *ngIf="isEdit && !transactionDone">
                    <div class="label-new" style="color: #333;">Unit</div>
                    <span class="inLneBlk nosWid fieldPad" *ngIf="!transactionDone" > <!-- data.ItemID == 0-->
                        <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                            <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                            <mat-autocomplete #autoUnit="matAutocomplete">
                                <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                    <span>{{x.UNm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>
                
                <!-- <div class="col-md-2 col-4 col-sm-4 inLneBlk pad0">
                 <span *ngIf="isERPGold && data.ItemID != 0" class="orangeBadge label yellowBadge mrgnTop10 fntSz brdrRadius3" (click)="uploadBiziFile()"  style="margin:0px 0px;padding: 4px 8px; cursor: pointer;">
                    <i class = "{{hasImg ? 'fa fa-pencil' : 'zmdi zmdi-plus'}}" style="padding-right: 2px;"></i>                  
                    <span style="margin-left:4px;">Image</span>
                </span>
                </div> -->

                 

            </div>
            
            <div *ngIf="isERPGold == true" class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 dspFlex mT10" style="align-items: center;" *ngIf="!transactionDone">
                    <span class="inLneBlk qtyWidth fieldPad width50" style="width: 38%;" [style.width]="!isMobileView ? '38%' : ''" *ngIf="data.ItemID == 0">
                        <div class="label-new" style="color: #333;">Qty</div>
                        <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                            <!-- <mat-label>Qty</mat-label> -->
                            <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.Qty" captalize-first
                                maxlength="20">
                        </mat-form-field>
                    </span>
                    <span class="inLneBlk nosWid fieldPad width50 mL10-alt" style="width: 37%;" *ngIf="!transactionDone && !isEdit" > <!-- data.ItemID == 0-->
                        <div class="label-new" style="color: #333;">Unit</div>
                        <mat-form-field class="example-full-width font13" style="width: 100%;" appearance="outline">
                            <input matInput placeholder="Unit" (blur)="selectUnit()" tabindex="1" [(ngModel)]="data.Unit"
                                [matAutocomplete]="autoUnit" [formControl]="unitCtrl">
                            <mat-autocomplete #autoUnit="matAutocomplete">
                                <mat-option *ngFor="let x of filteredUnit | async" [value]="x.UNm">
                                    <span>{{x.UNm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="lableBtnOrange adjustPos" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative;" (click)="openUnit()" title="Add New Unit">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>
                <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10 mL10"  *ngIf="data.ItemID == 0">
                    <div class="label-new" style="display: block; color: #333; padding-bottom: 3px;">Store</div>
                    <span class="fieldPad dspFlex" style="align-items: baseline;">
                        <mat-form-field class="example-full-width font13" [style.width]="isMobileView ? '100%' : '80%'" appearance="outline">
                            <!-- <mat-label>Store</mat-label> -->
                            <input matInput (blur)="selectStore()" tabindex="1"
                                [(ngModel)]="data.storeName" [matAutocomplete]="autoStore" [formControl]="StoreCtrl">
                            <mat-autocomplete #autoStore="matAutocomplete">
                                <mat-option *ngFor="let x of filterStore | async" [value]="x.sNm">
                                    <span>{{x.sNm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <span class="lableBtnOrange" *ngIf="rights.InvCfg" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="openStore()" title="Add New Store">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                        <!-- <span class="btn btn-orange fntSz" (click)="openStore();" title="dd Store"
                            style="cursor: pointer; margin-left: 10px; line-height: 23px; padding: 4px 8px; font-size: 17px; display:none">
                            <span>
                                <i class="zmdi zmdi-store" aria-hidden="true"></i>
                            </span>
                        </span> -->
                    </span>
                </div>                
                <div class="col-md-2 col-4 col-sm-4 inLneBlk pad0 mrginrightIMPItm webView" *ngIf="!isEdit" style="display: inline-block;">
                    <!-- Important -->
                    <div class="label-new" style="color: #333;">Importance</div>
                    <span class="inLneBlk nosWid fieldPad"  style="width: 100%;">
                        <mat-form-field class="example-full-width wdt font13" appearance="outline">
                            <!-- <mat-label>Importance</mat-label> -->
                            <input matInput tabindex="1" [(ngModel)]="data.IMPTtemTyp"
                                [matAutocomplete]="autoItemIMP" [formControl]="impItemCtrl">
                            <mat-autocomplete #autoItemIMP="matAutocomplete">
                                <mat-option *ngFor="let x of itemImportant" [value]="x.itemType">
                                    <span>{{x.itemType}}</span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                </div>
                <div class="col-md-3 col-4 col-sm-4 inLneBlk pad0" *ngIf="isExpirableBatch && isShowBatch">
                    <span class="label orangeBadge mrgnTop10 fntSz brdrRadius3"
                    (click)="openBatchSelectionMdl()" style="cursor: pointer; margin-left: 15px;">
                    <span style="margin-right: 5px">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </span> <span>Batches</span>
                    </span>
                </div>
             
            </div>


            <div class="col-md-12 col-12 col-sm-12 webView font13 pad0">
                <span class="label darkBlueBadge-wb mrgnTop10 fntSz {{modeType == 1 ? 'darkBlueBadge-wb-active' : ''}}"
                    (click)="changeMode('1')" style="cursor: pointer; margin-left: 0px; height: 30px;">
                    <span style="margin-right: 5px">
                        <i class="fa fa-square" aria-hidden="true"></i>
                    </span> <span>Products</span>
                </span>
                <span class="label darkBlueBadge-wb mrgnTop10 fntSz {{modeType == 2 ? 'darkBlueBadge-wb-active' : ''}}"
                    (click)="changeMode('2')" style="cursor: pointer; margin-left: 10px; height: 30px">
                    <span style="margin-right: 5px">
                        <i class="fa fa-square" aria-hidden="true"></i>
                    </span> <span>Materials</span>
                </span>
                <span class="label darkBlueBadge-wb mrgnTop10 fntSz {{modeType == 3 ? 'darkBlueBadge-wb-active' : ''}}"
                    (click)="changeMode('3')" style="cursor: pointer; margin-left: 10px; height: 30px">
                    <i class="fa fa-square" aria-hidden="true"></i><span style="margin-left: 5px">Spares</span>
                </span>
                <span class="label darkBlueBadge-wb mrgnTop10 fntSz {{modeType == 4 ? 'darkBlueBadge-wb-active' : ''}}"
                    (click)="changeMode('4')" style="cursor: pointer; margin-left: 10px; height: 30px">
                    <span style="margin-right: 5px">
                        <i class="fa fa-square" aria-hidden="true"></i>
                    </span><span>Assemblies</span>
                </span>
                <!-- <span class="label yellowBadge mrgnTop10 fntSz {{modeType == 3 ? 'activeYellow' : ''}}"
                    (click)="changeMode('3')" style="cursor:pointer;margin-left:10px; "><span style="margin-right:5px"><i
                            class="fa fa-square" aria-hidden="true"></i></span><span>Services</span></span> -->
                <span style="margin-left: 20px;">
                    <mat-checkbox class="example-margin chkbox-darkblue" [(ngModel)]="data.IsMade" tabindex="1">Internal Manufacturing
                    </mat-checkbox>
                </span>
                <span class="PurchaseLef" style="margin-left: 20px;">
                    <mat-checkbox class="example-margin chkbox-darkblue" [(ngModel)]="data.IsPurchased" tabindex="1">Purchase</mat-checkbox>
                </span>

                <span *ngIf="showItemImage && data.ItemID != 0" class="orangeBadge label  mrgnTop10 fntSz brdrRadius3" (click)="uploadBiziFile()"  style="position: relative; top: -3px;
                 margin-left: 15px; padding: 4px 8px; cursor: pointer;">
                    <i class = "{{hasImg ? 'fa fa-pencil' : 'zmdi zmdi-plus'}}" style="padding-right: 2px;"></i>                  
                    <span style="margin-left:4px;">Image</span>
                </span>
                
            </div>
                      
            <div *ngIf="isRateView" class="col-md-12 col-sm-12 col-12 pad0 mrgntp8 webView" style="text-align: left; margin-top: 20px;">
                <div class="col-md-3 col-sm-12 col-12 inLneBlk font13 pad0">
                    <div class="label-new">Std. Cost</div>
                    <div>
                        <span class="inLneBlk">
                            <!-- <i class="zmdi zmdi-widgets" style="color: #2b7fb3;"></i> -->
                            <span style="margin-left: 5px;"></span> 
                            <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                        </span>
                        <span class="inLneBlk fieldPad" style="width: 120px;">
                            <!-- <input type="text" tabindex="1" class="form-control wdh50" style="width: 110px; text-align:right"
                                title="Stock Rate" placeholder="Stock Rate" (ngModelChange)="changeStockRate($event)"
                                [(ngModel)]="data.stockRate" numbers_only maxlength="7"
                                (keypress)="CmnService.numberOnly($event)" /> -->
                            <mat-form-field class="example-full-width wdh50 font13" style="width: 140px; text-align: right; left: -25px;" appearance="outline">
                                <!-- <mat-label>Std Cost</mat-label> -->
                                <input class="iconField" matInput tabindex="1" [(ngModel)]="data.stockRate"
                                    captalize-first maxlength="10"
                                    (keypress)="CmnService.numberOnly($event)" (blur)="changeStockRate($event);">
                            </mat-form-field>
                            <!-- (ngModelChange)="changeStockRate($event)"  -->
                        </span>
                        <span class="font12"> / {{data.Unit}}</span>
                   </div>
                </div>
                <div  class="col-md-3 col-sm-12 col-xs-12 inLneBlk font13 pad0">
                    <div class="label-new" style="padding-left: 5px;">Purch. Cost</div>
                    
                   <div>
                        <span class="inLneBlk">
                            <!-- <i class="fa fa-shopping-cart" style="color: #4caf50;"></i> -->
                            <span style="margin-left: 5px;">
                            </span> 
                            <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                        </span>
                        <span class="inLneBlk fieldPad" style="width: 120px;">
                            <!-- <input type="text" tabindex="1" class="form-control wdh50" style="width: 112px; text-align:right"
                                title="Purch Cost" placeholder="Purch Cost" [(ngModel)]="data.purchaseCost"
                                (keypress)="CmnService.numberOnly($event)" maxlength="7" /> -->
                            <mat-form-field class="example-full-width wdh50 font13" style="width: 140px; text-align: right; left: -25px;" appearance="outline">
                                <!-- <mat-label>Purch Cost</mat-label> -->
                                <input class="iconField" matInput tabindex="1" [(ngModel)]="data.purchaseCost" captalize-first maxlength="10"
                                    (keypress)="CmnService.numberOnly($event)" (blur)="enterStockRate();">
                            </mat-form-field>
                        </span>
                        <span class="font12"> / {{data.Unit}}</span>
                   </div>
                </div>
                <div class="col-md-3 col-sm-12 col-xs-12 inLneBlk font13 pad0">
                    <div class="label-new" style="padding-left: 5px;">Std Sale Price</div>
                    <div>
                        <span class="inLneBlk">
                            <!-- <i class="zmdi zmdi-money-box" style="color: #e88421; font-size: 15px;"></i> -->
                            <span style="margin-left: 10px;"></span>
                            <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                        </span>
                        <span class="inLneBlk fieldPad" style="width: 115px;">
                            <!-- <input type="text" tabindex="1" class="form-control wdh50" style="width: 108px; text-align:right"
                                title="Sale Price" placeholder="Sale Price" [(ngModel)]="data.salePrice"
                                (keypress)="CmnService.numberOnly($event)" maxlength="7" /> -->
                            <mat-form-field class="example-full-width wdh50 font13" style="width: 135px; text-align: right; left: -25px;" appearance="outline">
                                <!-- <mat-label>Std Sale Price</mat-label> -->
                                <input class="iconField" matInput tabindex="1" [(ngModel)]="data.salePrice" (ngModelChange)="fn_changeMRPRate($event)" captalize-first maxlength="15"
                                    (keypress)="CmnService.numberOnly($event)" (blur)="enterStockRate();">
                            </mat-form-field>
                        </span>
                        <span class="font12">/ {{data.Unit}}</span>
                   </div>
                </div>
                <div class="col-md-3 col-sm-12 col-xs-12 inLneBlk font13 pad0" *ngIf="isShowCatWiseRateBtn">
                    <span class="inLneBlk darkBlueBadge fntSz font13 overFlowHidden brdrRadius3" style="cursor: pointer;" (click)="openCategoryWiseRateMdl(categoryRate);">
                        <div style="display: inline-flex; justify-content: space-between; align-items: center; column-gap: 4px;">
                            <i class = "fa fa-sitemap" style="padding-right: 2px;"></i>
                            <span>Customer Category-wise Rates</span>
                        </div>
                    </span>
                </div>
                <div *ngIf="isIndian" class="col-md-12 col-12 col-sm-12 inLneBlk" style="padding: 0px; margin-bottom: {{enableMRP ? '20px' : '0px'}};">
                    <span style="display: flex;">
                        <!-- HSN\SAC -->
                        <span class="inLneBlk fieldPad pad0 padR15">
                            <span class="label-new" style="color: #333; padding-bottom: 0; display: block;">HSN/SAC</span>
                            <mat-form-field class="example-full-width font13" appearance="outline">
                                <input matInput (blur)="selectHSN()" tabindex="1"
                                    [(ngModel)]="data.HSN" [matAutocomplete]="autoHSn" [formControl]="HSNCtrl">
                                <mat-autocomplete #autoHSn="matAutocomplete">
                                    <mat-option *ngFor="let x of filterHSN | async" [value]="x.H">
                                        <span>{{x.H}} </span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </span>
                        <!-- GST -->
                        <span class="inLneBlk font13 fieldPad pad0 padR15">
                            <span class="label-new" style="color: #333; padding-bottom: 0px; display: block;">GST</span>
                            <mat-form-field class="example-full-width wdh50" style="text-align: right; width: 50px" appearance="outline">
                                <!-- <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="2" [disabled]="IsDisable"
                                    placeholder="GST" (keypress)="CmnService.numberOnly($event)"> -->
                                    <!-- <mat-label style="padding-right: 6px;">GST</mat-label> -->
                                <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="4"
                                    (keypress)="CmnService.numberOnly($event)" 
                                    (ngModelChange)="fn_gstCount()">
                            </mat-form-field>
                            %
                        </span>
                        <!-- MRP -->
                        <span *ngIf="enableMRP" class="inLneBlk pad0 mrgnLft0 font13 pad0 padR15">
                            <span class="label-new" style="color: #333; padding-bottom: 0px; margin-left: 5px;">Price Incl. Tax</span>
                            <div>
                                <span class="inLneBlk">
                                    <span style="margin-left: 10px;"></span>
                                    <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                                </span>
                                <span class="inLneBlk fieldPad" style="width: 115px;">
                                    <mat-form-field class="example-full-width wdh50 font13" style="width: 135px; text-align: right; left: -25px;" appearance="outline">
                                        <input class="iconField" matInput tabindex="1" [(ngModel)]="data.mrpRate" (ngModelChange)="revCalculateMRP()" maxlength="7"
                                            (keypress)="CmnService.numberOnly($event)">
                                    </mat-form-field>
                                </span>
                                <span class="font12">/ {{data.Unit}}</span>
                            </div>
                        </span>
                        <!-- MRP Price -->
                        <span *ngIf="isB2C" class="inLneBlk pad0 mrgnLft0 font13 pad0">
                            <span class="label-new" style="color: #333; padding-bottom: 0px; margin-left: 5px;">MRP</span>
                            <div>
                                <span class="inLneBlk">
                                    <span style="margin-left: 10px;"></span>
                                    <span class="iconBox">{{myCurrency.symbol ? myCurrency.symbol : '₹'}}</span>
                                </span>
                                <span class="inLneBlk fieldPad" style="width: 115px;">
                                    <mat-form-field class="example-full-width wdh50 font13" style="width: 135px; text-align: right; left: -25px;" appearance="outline">
                                        <input class="iconField" matInput tabindex="1" [(ngModel)]="data.mrpPrice" (ngModelChange)="revCalculateMRP()" maxlength="7"
                                            (keypress)="CmnService.numberOnly($event)">
                                    </mat-form-field>
                                </span>
                                <span class="font12">/ {{data.Unit}}</span>
                            </div>
                        </span>
                    </span>
                </div>
            </div>

            <!-- Description -->
            <div class="col-md-12 col-sm-12 col-12 {{enableMRP ? 'mT0' : ''}} pad0" style="text-align: left;">
                <div class="col-md-12 col-sm-12 col-12 pad0 mrgntp8">
                    <div class="col-md-6 col-sm-6 col-12 pad0" style="display: inline-block;">
                        <div class="label-new" style="color: #333;">Description (will be suggested in documents like invoices, orders, etc.)</div>
                        <!-- <textarea type="text" title="Description"
                            placeholder="Description (will be suggested in documents like invoices, orders, etc.)"
                            class="form-control brdrColor"
                            style="white-space: pre-line; border: 1px solid #ddd !important ; resize: none; border-radius: 10px !important; padding: 10px;"
                            rows="2" [(ngModel)]="data.description" maxlength="200" captalize-first tabindex="1"></textarea> -->
                        <mat-form-field out class="example-full-width myText font13 notes" appearance="outline"
                            style="width: 100%; padding-bottom: 10px;">
                            <!-- <mat-label>Description (will be suggested in documents like invoices, orders, etc.)</mat-label> -->
                            <textarea matInput rows="2" style="resize: none;" [(ngModel)]="data.description" maxlength="1000"
                                tabindex="1"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-sm-6 col-12 padd0 mT10" style="display: inline-block;">
                        <div class="label-new" style="color: #333;">Internal Notes</div>
                        <mat-form-field out class="example-full-width myText font13 notes" appearance="outline"
                            style="width: 100%; padding-bottom: 10px;">
                            <!-- <mat-label>Internal Notes</mat-label> -->
                            <textarea matInput rows="2" style="resize: none;" [(ngModel)]="data.internalNotes"
                                maxlength="200" tabindex="1"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <!-- HSN\SAC, GST, Min Stock, Lead Time -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <!-- HSN\SAC -->
                <div *ngIf="isIndian && !enableMRP && false" class="col-md-2 col-6 col-sm-6 inLneBlk pad0">
                    <span class="inLneBlk fieldPad">
                        <div class="label-new" style="color: #333;">HSN/SAC</div>
                        <mat-form-field class="example-full-width font13" style="width: 75%;" appearance="outline">
                            <input matInput (blur)="selectHSN()" tabindex="1"
                                [(ngModel)]="data.HSN" [matAutocomplete]="autoHSn" [formControl]="HSNCtrl">
                            <mat-autocomplete #autoHSn="matAutocomplete">
                                <mat-option *ngFor="let x of filterHSN | async" [value]="x.H">
                                    <span>{{x.H}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                </div>
                <!-- GST -->
                <div *ngIf="isIndian && !enableMRP && false" class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mL40">
                    <span class="inLneBlk font13 fieldPad" style="width: 65%;">
                        <div style="display: block;">
                            <div class="label-new" style="color: #333; padding-bottom: 0px;">GST</div>
                        </div>
                        <mat-form-field class="example-full-width wdh50" style="width: 60%; text-align: right" appearance="outline">
                            <!-- <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="2" [disabled]="IsDisable"
                                placeholder="GST" (keypress)="CmnService.numberOnly($event)"> -->
                                <!-- <mat-label>GST</mat-label> -->
                            <input matInput tabindex="1" [(ngModel)]="data.HsnPer" captalize-first maxlength="4"
                                (keypress)="CmnService.numberOnly($event)" 
                                (blur)="calMrpGST();">
                        </mat-form-field>
                        %
                    </span>
                </div>
                <!-- Min Stock -->
                <div class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mrgnLft0 font13" style="margin-left: {{isIndian ? '0px' : ''}};">
                    <span class="inLneBlk fieldPad" style="width: 60%;">
                        <div class="label-new" style="color: #333;">Min Stock</div>
                        <!-- <input type="text" id="txtItem " class="form-control " tabindex="1" placeholder="Min Level Qty"
                            title="minimum Stock Qty" [(ngModel)]="data.minStockQty" style="text-align: right;" /> -->
                        <mat-form-field class="example-full-width" style="width: 90%;" appearance="outline">
                            <!-- <mat-label>Min Stock</mat-label> -->
                            <input matInput tabindex="1" class="txtRight" (keyup)="enterQty()" (blur)="prcnQty()"
                                (keypress)="CmnService.numberOnly($event)" [(ngModel)]="data.minStockQty" maxlength="7">
                        </mat-form-field>
                    </span>
                    <span class="font12" style="margin-left: -10px;">
                        {{data.Unit}}
                    </span>
                </div>
                <!-- Lead Time -->
                <div class="col-md-2 col-6 col-sm-6 inLneBlk pad0 mrgnLft0" style="margin-left: 10px;">
                    <div class="label-new" style="color: #333;">Lead Time</div>
                    <span class="Left0 fieldPad">
                        <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.leadTime" tabindex="1"
                            placeholder="Lead Time" title="Lead Time" captalize-first style=" width: 75%;text-align: right;"
                            (keypress)="CmnService.numberOnly($event)" /> -->

                        <mat-form-field class="example-full-width font13" style="width: 75%;" appearance="outline">
                            <!-- <mat-label>Lead Time</mat-label> -->
                            <input matInput tabindex="1" class="txtRight" (keypress)="CmnService.numberOnly($event)"
                                [(ngModel)]="data.leadTime" maxlength="3">
                        </mat-form-field>
                        <span style="font-size: 13px;"> {{ data.leadTime == 1 ? 'day' : 'days' }}</span>
                    </span>
                </div>
              </div>
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-3 col-12 col-sm-12 inLneBlk pad0 mT10">
                    <div class="label-new" style="color: #333; display: block;">Tags</div>
                    <span class="fieldPad">
                        <!-- <input type="text" id="txtItem" class="form-control " [(ngModel)]="data.tag" tabindex="1"
                            (ngModelChange)="chagetagValue()" placeholder="Enter Tag" title="Tag" captalize-first
                            style=" width: 100%;" (change)="tagEntry()" /> -->
                        <!-- <mat-form-field class="example-full-width" style="width: 90%;">
                            <mat-label>Enter Tag</mat-label>
                            <input matInput tabindex="1" [(ngModel)]="data.tag" maxlength="20">
                        </mat-form-field> -->
                        <mat-form-field class="example-full-width Wid87 font13" style="width: 60%;" appearance="outline">
                            <!-- <mat-label>Tags</mat-label> -->
                            <input matInput tabindex="1" maxlength="20" [(ngModel)]="data.tag"
                                [matAutocomplete]="autoTag" [formControl]="TagCtrl">
                            <mat-autocomplete #autoTag="matAutocomplete">
                                <mat-option *ngFor="let x of filterTag | async" [value]="x.Tnm">
                                    <span>{{x.Tnm}} </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </span>
                    <span class="lableBtnOrange" style="margin-left: 5px; padding: 2px 10px; height: 30px !important; position: relative; bottom: 1px;" (click)="tagEntry()">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>
                <div class="col-md-9 col-sm-12 col-12 inLneBlk mrgntp8 pad0 mT40 mT10" style="text-align: left;">
                    <div class="TagLeft0 brdrRadius3" style="display: inline-block; border: 1px solid #ddd; padding: 3px 9px; margin-top: 5px; margin-left: 5px; background: #f0f0f0 !important; color: #333; font-size: 14px;"
                        *ngFor="let x of tagList; let i = index">
                        <span>
                            {{x}}
                        </span>
                        <span style="margin-left: 10px; cursor: pointer;" (click)="removeTagSearch(i)">
                            <i class="zmdi zmdi-close"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12 mT20Mob pad0">
                <div class="col-md-4 col-12 col-sm-6 inLneBlk pad0" style="font-size: 13px; display: flex; gap: 10px;">
                    <span class="btn-darkGreen ng-scope brdrRadius3" style="padding: 2px 7px 1px; height: 30px;" (click)="save()">
                        <i class="fa fa-check" style="margin-right: 5px;"></i>
                        {{data.ItemID == 0 ? 'Save' : 'Update'}}
                    </span>
                    <span *ngIf="!showAsPage" class="darkBlueButton mobView" style="display: inline-block; height: 30px; padding: 6px 9px 1px !important;" (click)="closeModel()">
                        <i class="fa fa-close" style="margin-right: 5px;"></i>Close
                    </span>
                    <span *ngIf="showAsPage" class="btn darkBlueButton" (click)="backToHomeBtn()">
                        <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

    <!-- Category Selection Modal -->
    <ng-template #CategoryEntry let-modal>
        <app-categories></app-categories>
    </ng-template>

    <!-- SubCategory Selection Modal -->
    <ng-template #subCategories let-modal>
        <app-multiple-select-item (newItemEvent)="getSelectedItem($event)"></app-multiple-select-item>
    </ng-template>

    <!-- Store selection  -->
    <ng-template #StoryEntry let-modal>
        <app-stores></app-stores> 
    </ng-template>

  <!--Category wise Rate mdl-->
  <ng-template #categoryRate let-modal>
    <!--Header-->
    <div class="modal-header">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
              <h5 class="modal-title"><span id="ApntmntHdr">Customer Category-wise Rates</span></h5>
            </div>
            <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
              <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
          </div>
        </div>
      </div>
    <!--Body-->
    <div class="modal-body">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
            <div *ngFor="let s of categoryList let i = index" style="margin-bottom: 10px;border-radius: 10px;"
                class="col-12 col-sm-12">
                <div class="row">
                    <div class="col-md-9 col-sm-9 col-9 font13" style="padding: 0px;" title="">
                        <span style="vertical-align: -webkit-baseline-middle;">{{s.CNm}}</span>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 font13" style="text-align: right; padding: 0px;">
                        <div class="label-new" style="display: block; padding-bottom: 1px; text-align: left;">
                            Discount
                        </div>
                        <div style="display: flex;">
                            <input (keypress)="CmnService.numberOnly($event)" (keyup)="setDiscount(s)"
                                class="form-control formCtlFltr" type="text" id="category" placeholder="Discount"
                                name="category" [(ngModel)]="s.D"
                                style="text-align: right; vertical-align: middle; margin-right: 5px; position: relative; top: 0px;">
                            <span style="margin-top: 6px;">%</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12" style="text-align: left; padding: 0px; margin-top: 15px;">
                <span class="btn-green brdrRadius3" (click)="saveCatRate()" style="padding: 2px 8px; font-size: 13px;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i>Save
                </span>
                <span *ngIf="isShowPropose" class="btn-yellow brdrRadius3" (click)="proposeDiscount();"
                    style="margin-left: 10px; padding: 3px 8px; font-size: 13px;">
                    <i class="fa fa-magic" style="margin-right: 5px;"></i>Propose Rate
                </span>
    
            </div>
        </div>
    </div>
    <!--Footer-->
   
  </ng-template>

    <ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

    </ngx-spinner>

<!-- Modal Template -->
<ng-template #barcodeOptionsTemplate let-modal>
    <div class="modal-header" style="background: rgb(248, 248, 248) !important; border-radius: 10px; padding-bottom: 15px !important;">
        <div class="col-md-12 col-sm-12 col-12">
            <div class="row">
                <div class="col-md-12 pad0" style="display: flex; align-items: center; margin-bottom: 10px; justify-content: space-between;">
                    <h4 class="lblHeader" style="font-size: 19px; margin: 0; display: flex; align-items: center;">Barcode Print</h4>
                    <div style="margin-top: -4px;"><i class="closeMdl zmdi zmdi-close" style="cursor: pointer; order: 1;" (click)="modal.dismiss('Cross click')"></i></div>
                </div>
                <div class="modal-body" style="padding: 0;">
                    <div style="padding: 0;">
                        <div style="display: flex; margin-bottom: 10px;">
                            <span style="font-size: 14px; color: #333; margin-right: 10px;">Display :</span>
                            <div style="display: flex; flex-direction: column;">
                              <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                    <mat-checkbox class="example-margin" [(ngModel)]="barcodeOptions.showName" tabindex="1">
                                    <span style="font-size: 14px; color: #333;">Item Name</span>
                                    </mat-checkbox>
                                    <div style="width: 20px;"></div>
                                    <mat-checkbox class="example-margin" [(ngModel)]="barcodeOptions.showPrice" (change)="toggleCheckbox('price')" tabindex="1" >
                                    <span style="font-size: 14px; color: #333;">Price</span>
                                    </mat-checkbox>
                              </div>

                              <div *ngIf="isB2C" style="display: flex; align-items: center;margin-top: -8px; margin-bottom: -8px;">
                                    <mat-checkbox class="example-margin" [(ngModel)]="barcodeOptions.showMRP" (change)="toggleCheckbox('mrp')" tabindex="1">
                                    <span style="font-size: 14px; color: #333;">MRP</span>
                                    </mat-checkbox>
                              </div>
                            </div>
                        </div>
                          
                        <div class="pad0 cmnMarg" style="display: flex; align-items: center;">
                            <div class="disFx" style="display: flex; align-items: center;">
                                <div>
                                    <div style="font-size: 14px; color: #333; margin-right: 32px;">Qty :</div>
                                </div>
                                <input type="number" class="form-control formCtlFltr" min="1" max="15" [(ngModel)]="barcodeOptions.count" style="width: 65px; text-align: right; padding: 8px 8px; margin-right: 5px; " numbers_only />
                                <div style="color: grey; font-size: 12px;">(up to 15)</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-xs-12 col-12" style="padding: 0; font-size: 13px; margin-top: 10px;">
                    <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px;" (click)="generateBarcode()">
                        <i class="zmdi zmdi-print" style="margin-right: 10px;"></i>
                        <span>Print</span>
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</ng-template>



  
  

<ng-template #unitEntry let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Add Unit</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div *ngIf="isEdit == false" class="col-md-6 col-xs-8 col-8 font13" style="padding: 0px 15px 10px 0px;display: inline-block;">
                <input type="text" [(ngModel)]="unit" class="form-control formCtlFltr brdrRadius3" maxlength="50" style="text-indent: 2px;font-size: 13px;" placeholder="Enter Unit">
            </div>
            <div *ngIf="isEdit == true" class="col-md-4 col-xs-5 col-5 font13" style="padding: 0px 15px 10px 3px;display: inline-block;">
                <span>{{unit}}</span>
            </div>
            <div *ngIf="isEdit == false" class="col-md-3 col-xs-4 col-4 preWidth font13" style="padding: 0px;display: inline-block;">
                <input type="text" numbersOnly [(ngModel)]="prcsn" class="form-control formCtlFltr brdrRadius3" maxlength="1"  style="text-indent: 2px; text-align: right;font-size: 13px;" placeholder="Precision">
            </div> 
            <div *ngIf="isEdit == true" class="col-md-3 col-xs-3 col-3 preWidth font13" style="padding: 0px;display: inline-block;">
                <input type="text" numbersOnly [(ngModel)]="prcsn" class="form-control formCtlFltr brdrRadius3" maxlength="1"  style="text-indent: 2px; text-align: right;font-size: 13px;" placeholder="Precision">
            </div>  
            <div class="col-md-9 col-xs-12 col-12 font13" style="display: inline-block;color: #DAA520;padding: 5px 0px 0px 5px;">
                <span>E.g. 3 precision = 0.123</span>
            </div>  
        </div>
        
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px; font-size: 13px;">
            <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px;" (click)="isEdit == false ? saveNewUnit(unit,prcsn) : editUnitSave(unit,prcsn)" >
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>            
        </div>
        
    </div>
</ng-template>